import * as React from 'react';

import { IPublishedConnectionInfo } from '../../ts/models/IPublishedConnectionInfo';
import { PublishedConnectionTablesGrid, PublishedConnectionTablesGridProps } from './tables/PublishedConnectionTablesGrid';

export type PublishedConnectionOverviewSubplaceProps = Readonly<{
  publishedConnectionInfo: IPublishedConnectionInfo;
}>;

export class PublishedConnectionOverviewSubplace extends React.Component<PublishedConnectionOverviewSubplaceProps, {}> {
  private getPublishedConnectionTablesGridProps = (): PublishedConnectionTablesGridProps => {
    return {
      publishedConnectionInfo: this.props.publishedConnectionInfo
    };
  }

  public render(): JSX.Element {
    return (
      <PublishedConnectionTablesGrid {...this.getPublishedConnectionTablesGridProps()} />
    );
  }
}
